const pmCompanyMockData = {
    id: 1085382,
    partner: {
        name: 'Nomad Lease'
    }
}

export default pmCompanyMockData;